import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {CModule} from 'shared/models/cmodules/cmodule';
import {ICModulesOverviewRepository} from './cmodules-overview.repository.interface';

@Injectable()
export class CModulesOverviewHttpRepository implements  ICModulesOverviewRepository {

  constructor(private http: Http) { }

  public getCModules(): Observable<Array<CModule>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.cmodules, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteCModule(id: string): Observable<void> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.cmodules}/${id}`, options)
      .map((response: Response) => {
        return;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-overview/repositories/cmodules-overview.repository.http.ts